import React from 'react';
import PrismDecorator from 'draft-js-prism';
//import { Prism } from 'prismjs'
//import {sql} from '../prism-sql'
//import 'prismjs/components/prism-sql'

import { useTooltip } from '../../../hooks';
import { Link } from 'react-router-dom';
import { Asset } from '../../../helpers';
import { formatTooltip } from '../helpers';
import Prism from '../helpers/prism-helper';
export const Reference = ({ children, entityKey, contentState, readOnly, descriptions }) => {
  const { object_id, object_name } =
    entityKey !== null && contentState.getEntity(entityKey).getData().reference;

  const { showTooltip, hideTooltip } = useTooltip();

  const body = <span className="textarea-reference">{children}</span>;

  if (readOnly && descriptions && descriptions.length > 0) {
    const description = descriptions.filter(
      x => x.to_object_id === object_id && x.to_object_name === object_name
    )[0];

    // Ugly fix to prevent errors related to the render lifecycle
    if (!description) {
      return body;
    }

    const { glossary_id, system_id, datasource_id, dataset_group_id } = description;

    let url = '';

    switch (object_name) {
      case Asset.Attribute:
        url = `/attributes/${object_id}`;
        break;
      case Asset.Entity:
        url = `/glossaries/${glossary_id}/${object_id}`;
        break;
      case Asset.Dataset:
        url = `/systems/${system_id}/${datasource_id}/${dataset_group_id}/${object_id}`;
        break;
      case Asset.System:
        url = `/systems/${object_id}`;
        break;
      default:
        break;
    }

    let tooltipData = formatTooltip({ ...description, object_name: description?.to_object_name });

    return (
      <Link to={url} onMouseEnter={() => showTooltip(tooltipData)} onMouseLeave={hideTooltip}>
        {body}
      </Link>
    );
  } else {
    return body;
  }
};

export const findReferenceEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    // Get data stored in entity
    // console.log(entityKey !== null && contentState.getEntity(entityKey).getData())
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'REFERENCE';
  }, callback);
};

export const prismDecorator = new PrismDecorator({
  prism: Prism,
  defaultSyntax: 'sql',
  filter: block => {
    return block.getType() === 'unstyled';
  },
});

const _decoratorCache = {};

/**
 * Returns a cached PrismDecorator for the given language.
 * @param {string} [language='sql']
 * @returns {PrismDecorator}
 */
export const getPrismDecorator = (language = 'sql') => {
  if (!_decoratorCache[language]) {
    _decoratorCache[language] = new PrismDecorator({
      prism: Prism,
      defaultSyntax: language,
      filter: block => block.getType() === 'unstyled',
    });
  }
  return _decoratorCache[language];
};
